import { IAnalyticalDetailsByPID } from "@redux/reducers/analyticalPBFReducer";

export enum ActionType {
  ANALYTICAL_DETAILS_BY_PID = "ANALYTICAL_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IAnaltyicalProjectDetailsByPid {
  type: ActionType.ANALYTICAL_DETAILS_BY_PID;
  payload: IAnalyticalDetailsByPID[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IAnaltyicalProjectDetailsByPid | IResetReduxState;
